import styled from "styled-components";

const JobHeader = styled.div`
  margin: 0 0 96px 0;
`;

export { JobHeader };
